import { useState } from "react";
import CLIENTS from "config/clients";
import logoWhite from "assets/images/suntech_logo_white.png";

const S = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0D142A 0%, #1A3A6B 100%)",
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 16,
    padding: "40px 36px",
    backdropFilter: "blur(12px)",
    boxShadow: "0 24px 60px rgba(0,0,0,0.5)",
  },
  logo: {
    textAlign: "center",
    marginBottom: 32,
  },
  logoText: {
    fontSize: 28,
    fontWeight: 800,
    color: "#fff",
    letterSpacing: 1,
  },
  logoSub: {
    fontSize: 12,
    color: "#C9A84C",
    letterSpacing: 2,
    textTransform: "uppercase",
    marginTop: 4,
  },
  divider: {
    width: 40,
    height: 3,
    background: "#C9A84C",
    borderRadius: 2,
    margin: "12px auto 0",
  },
  label: {
    display: "block",
    fontSize: 11,
    fontWeight: 600,
    color: "#A0B4D0",
    letterSpacing: 1,
    textTransform: "uppercase",
    marginBottom: 8,
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 8,
    color: "#fff",
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box",
    transition: "border 0.2s",
  },
  inputFocus: {
    border: "1px solid #C9A84C",
  },
  field: { marginBottom: 20 },
  btn: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(135deg, #1A3A6B, #0075FF)",
    border: "none",
    borderRadius: 8,
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    marginTop: 8,
    letterSpacing: 0.5,
    transition: "opacity 0.2s",
  },
  error: {
    background: "rgba(220,38,38,0.15)",
    border: "1px solid rgba(220,38,38,0.4)",
    borderRadius: 8,
    color: "#FC8181",
    fontSize: 13,
    padding: "10px 14px",
    marginBottom: 16,
    textAlign: "center",
  },
  footer: {
    textAlign: "center",
    marginTop: 28,
    fontSize: 11,
    color: "#C9A84C",
  },
};

export default function Login({ onLogin }) {
  const [code, setCode]       = useState("VERTEX2026");
  const [password, setPassword] = useState("Vertex@123");
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);
  const [focusCode, setFocusCode]   = useState(false);
  const [focusPw, setFocusPw]       = useState(false);
  const [showPw, setShowPw]         = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    setTimeout(() => {
      const key    = code.trim().toUpperCase();
      const client = CLIENTS[key];

      if (!client) {
        setError("Access code not recognised.");
        setLoading(false);
        return;
      }
      if (client.password !== password) {
        setError("Incorrect password.");
        setLoading(false);
        return;
      }

      // Store session
      localStorage.setItem("finops_auth", JSON.stringify({ code: key, company: client.company, period: client.period }));
      onLogin({ company: client.company, period: client.period });
      setLoading(false);
    }, 600);
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        {/* Logo */}
        <div style={S.logo}>
          <img src={logoWhite} alt="Suntech" style={{ width: 200, marginBottom: 8 }} />
          <div style={S.logoSub}>FinOps Platform</div>
          <div style={S.divider} />
        </div>

        {/* Error */}
        {error && <div style={S.error}>{error}</div>}

        {/* Form */}
        <form onSubmit={handleLogin} autoComplete="off">
          <div style={S.field}>
            <label style={S.label}>Access Code</label>
            <input
              style={{ ...S.input, ...(focusCode ? S.inputFocus : {}) }}
              type="text"
              placeholder="e.g. VERTEX2026"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onFocus={() => setFocusCode(true)}
              onBlur={() => setFocusCode(false)}
              autoComplete="off"
              required
            />
          </div>
          <div style={S.field}>
            <label style={S.label}>Password</label>
            <div style={{ position: "relative" }}>
              <input
                style={{ ...S.input, ...(focusPw ? S.inputFocus : {}), paddingRight: 44 }}
                type={showPw ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusPw(true)}
                onBlur={() => setFocusPw(false)}
                required
              />
              <span
                onClick={() => setShowPw(!showPw)}
                style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#556581", fontSize: 13, userSelect: "none" }}
              >
                {showPw ? "HIDE" : "SHOW"}
              </span>
            </div>
          </div>
          <button style={S.btn} type="submit" disabled={loading}>
            {loading ? "Verifying…" : "Sign In →"}
          </button>
        </form>

        <div style={S.footer}>
          Suntech Business Solutions · Confidential<br />
          Contact your administrator for access
        </div>
      </div>
    </div>
  );
}
